export default "__VITE_ASSET__BVqhyk7a__"